export const userData = [
  {
    name: "Jan",
    "Active User": 4000,
  },
  {
    name: "Feb",
    "Active User": 3000,
  },
  {
    name: "Mar",
    "Active User": 2000,
  },
  {
    name: "Apr",
    "Active User": 2780,
  },
  {
    name: "May",
    "Active User": 1890,
  },
  {
    name: "Jun",
    "Active User": 2390,
  },
  {
    name: "Jul",
    "Active User": 3490,
  },
  {
    name: "Aug",
    "Active User": 3890,
  },
  {
    name: "Sept",
    "Active User": 3790,
  },
  {
    name: "Oct",
    "Active User": 3690,
  },
  {
    name: "Nov",
    "Active User": 3590,
  },
  {
    name: "Dec",
    "Active User": 3390,
  },
];
export const productData = [
  {
    name: "Jan",
    Sales: 4000,
  },
  {
    name: "Feb",
    Sales: 3000,
  },
  {
    name: "Mar",
    Sales: 2000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 2,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 3,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 4,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 5,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 6,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 7,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 8,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 9,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
  {
    id: 10,
    username: "Jon Snow",
    avatar:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Jon_Snow_Season_8.png",
    email: "jon@gmail.com",
    status: "Active",
    transaction: "$1000.00",
  },
];

export const productRows = [
  {
    id: 1,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 2,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 3,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 4,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 5,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 6,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 7,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 8,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 9,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
  {
    id: 10,
    name: "Apple Phone",
    img: "https://www.alephksa.com/wp-content/uploads/iPhone_14_Pro_Deep_Purple_PDP_Image_Position-1a_EN-1-scaled.jpg",
    stoke: 123,
    status: "Active",
    price: "$1000.00",
  },
];
